import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { FinancialItemContainerModel } from '../../../../../../models/aggregates/erp/financial';
import { Core2Config } from '../../shared/core2Config';

//  /core2/tnt/dm/erp/fi/fi-items/login-entity-ep

@Injectable({
  providedIn: 'root'
})
export class FinancialItemLoginEntityEpService extends BaseApiTemplateService<FinancialItemContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-items/login-entity-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-items/login-entity-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-items/login-entity-ep';
    this.httpClient = http;
  }

}
